export function footerList() {

    const footerListBtn = document.querySelectorAll('.js-footerListBtn');

    footerListBtn.forEach( item => {
        item.addEventListener('click', () => {
            item.classList.toggle('is-active');
            item.parentNode.querySelector('.js-footerListBlock').classList.toggle('is-active');
        });
    });
}